import { ItaEnvironment } from "../store/Profile/enum/Ita-environment";
import { ItaNonProdPolicy } from "../store/Profile/enum/Ita-nonprod-policy";
import { ItaProdPolicy } from "../store/Profile/enum/Ita-prod-policy";

export type ApiResponse = Record<string, any>;

export interface IAuctionResponse extends ApiResponse {
  auctions: IAuction[];
}

export interface IAuction {
  id: number;
  auctionName: string;
  corridor: string;
  product: string;
  biddingClose: Date;
  ftroption: string;
  identification: string;
  maintenances: IMaintenance[];
  productDetails: IProductDetails[];
  biddingOpen: Date;
  productResults: IProductResult[];
  cancelled: boolean;
  lastDataUpdate: Date;
  isBidGateOpen: boolean;
  interconnector?: string;
  periodStart?: Date;
  periodStop?: Date;
  bidStatus: string;
  bidResult: IBidResult;
  hasSuccessfullyBid: boolean;
  successfullyBidResult: IBidResult;
  books: IBook[];
  exchangeId: number;
  exchangeCode: string;
  auctionResultStatus: string;
  auctionResult: IItaAuctionResult;
  capacityReturn: ICapacityReturn;
  publishResultsDateTime?: Date;
  capacityReturnGateOpen?: Date;
  capacityReturnGateClose?: Date;
}

export interface IBid {
  id: number;
  bidGuid: string;
  auctionIdentification?: string;
  corridorCode?: string;
  bidPanelRowDetails?: IBidPanelRowDetails[];
  bidItems: IBidItem[];
  status: BidStatus;
  isDirty: boolean;
  exchangeId: number;
}

export interface IBidPanelRowDetails {
  corridorCode: string;
  bidGuid?: string;
  productHour: string;
  offeredCapacity: number;
  quantity: any;
  price: any;
  position: number;
}

export interface IBidCreation {
  auctionIdentification: string;
  product: string;
  book?: string;
  startDateTimeUtc: Date;
  endDateTimeUtc: Date;
  bids: IBidItem[];
  status: string;
  maintenance?: IMaintenance[];
  exchangeId: number;
}

export interface IBidItem {
  bidId: number;
  bidGuid?: string;
  startDateTimeUtc: Date;
  endDateTimeUtc: Date;
  bidStatus: string;
  period: IInterval[];
}

export interface ISubmissionHistory {
  documentId?: string;
  submissionHistoryItems?: ISubmissionHistoryItems[];
  loading: boolean;
}

export interface ISubmissionHistoryItems {
  documentId: string;
  version: number;
  submissionStatus: string;
  createdDateTime: Date;
}

export interface IInterval {
  quantity: number;
  priceAmount: number;
  position: number;
  offeredCapacity: number;
}

export interface IItaAuctionResult {
  auctionId: string;
  uniqueResultsId: string;
  zkey: string;
  book: string;
  hasCapacityWon: boolean;
  results: IResultAtProductHour[];
}

export interface ICapacityReturn {

}

export interface IResultAtProductHour {
  productHour: string;
  offeredPrice: number;
  capacityWon: number;
}

export enum BidStatus {
  Accepted = "Accepted",
  Amended = "Amended",
  Rejected = "Rejected",
  Cancelled = "Cancelled",
  Draft = "Draft",
  Submit = "Submit",
  Amend = "Amend",
  Revert = "Revert",
  Open = "Open",
  Closed = "Closed",
  Closing = "Closing soon",
  ServerError = "Server Error",
  DraftFailed = "Draft Failed",
}

export enum AuctionResultStatus { 
  AuctionOpen = "Auction Open", 
  NoSubmission = "No Submission",
  AwaitingResults = "Awaiting Results",
  CapacityWon = "Capacity Won",
  NoCapacityWon = "No Capacity Won"
}

export enum BidProductTypeEnum {
  Monthly = "Monthly",
  Weekly = "Weekly",
  Intraday = "Intraday",
  Daily = "Daily",
  NA = "NotApplicable",
}

export enum ExchangeTypeEnum {
  Jao = "JAO",
  Empire = "EMPIRE",
}

export enum BidMessageTypeEnum {
  success = "success",
  error = "error",
  default = "default",
  warning = "warning",
  info = "info",
}

export enum BidIconTypeEnum {
  error = "error",
  success = "success",
  info = "info",
}

export enum BidMessageEnum {
  default = "",
  success = "Bid has been successfully submitted.",
  failure = "Sorry, we couldn't submit your bid.",
  QuantityHigherThanCapacity = "Please ensure requested capacity is less or equal to offered capacity.",
  OnlyPositiveNumericsAllowed = "Please enter a positive numeric value only.",
  AllQuantityValuesAreaZero = "All Quantities have zero value. Please ensure at least one quantity field has positive numeric value.",
  PricesCannotBeInThreeDecimalPlaces = "Please ensure your price value is not in three decimal places.",
  CannotSubmitBid = "Sorry, we couldn't submit your bid.",
  CannotSubmitBidPlaceOrderDirectly = "Sorry we couldn't submit your bid, please place the order directly on the exchange.",
  CannotSaveDraftBid = "Unable to save Draft. Please-re-enter bid information.",
  SumOfBidQtyGTCapacity = "Please ensure that sum of requested capacity is less or equal to offered capacity for given interval. Please-re-enter bid information.",
  ErrorMessageFromTheExchange = "Error message from the exchange",
}

export enum BidButtonLabelEnum {
  Submit = "Submit Bid(s)",
  Resubmit = "Resubmit All Bids",
}

export enum AuctionMessageEnum {
  UnableToGetAuctionResult = "Unable to display auction data. Please refer to ITA team for more information, and visit JAO website for bidding activity if needed.",
}
export enum ConfigurationManagementEnum {
  UnableToGetExchangeConfig = "Unable to display exchange config data. Please refer to ITA support team for more information.",
  UnableToGetEtrmConfig = "Unable to display etrm config data. Please refer to ITA support team for more information.",
  ExchangeConfigPostSuccess = "The Exchange Config has been updated and all the Exchange Configs have been reloaded",
  UnableToPostExchangeConfig = "Unable to save Exchange Config data. Please refer to ITA support team for more information.", 
  EtrmConfigPostSuccess = "The ETRM Config has been updated and all the ETRM Configs have been reloaded",
  UnableToPostEtrmConfig = "Unable to save ETRM config data. Please refer to ITA support team for more information."
}

export enum ProfileEnum{
  UnableToFetchProfile = "Unable to fetch profile details. Redirecting to access denied page."
}

export enum AuditEnum {
  UnableToPostAudit = "Unable to post audit data. Please refer to ITA support team for more information."
}

export enum UserRoles {
  Write = "powr-ita-appwriter",
  Read = "powr-ita-appreader",
  Admin = "powr-ita-appadmin",
  WriteNonProd = "powr-ita-appwriter-nonprod",
  ReadNonProd = "powr-ita-appreader-nonprod",
  AdminNonProd = "powr-ita-appadmin-nonprod",
}

export interface IAuctionRequest {
  corridorCodes: string[];
  auctionDateTime: Date;
}

export interface IBidRequest {
  bids: IBid[];
}

export interface IPopulateBidQuantity {
  quantity: number;
}

export interface IProductDetails {
  corridorCode: string;
  productHour: string;
  offeredCapacity: number;
  productType: BidProductTypeEnum;
}

export interface IProductResult {
  allocatedCapacity: number;
  auctionPrice: number;
  corridorCode: string;
  productHour: string;
  productIdentification: string;
  requestedCapacity: number;
}

export interface ISourceAuction {
  exchangeCode: string;
  exchangeId: number;
  auctionId: string;
  auctionName: string;
  name: string;
  corridor: string;
  deliveryPeriodStart: string;
  deliveryPeriodEnd: string;
  availableAllocatedCapacity: number;
  clearingPrice: number;
}

export interface ICorridorDetail {
  corridorKey: string;
  interconnector?: string;
  corridor: string;
}

export interface IBidResult {
  documentId: string;
  bidGuid?: string;
  status: string;
  errors: string[];
  book?: string;
  bids: IBidItem[];
}

export interface IBidResultDetail {
  bidResult: IBidResult;
  hasSuccessfullyBid: boolean;
  successfullyBidResult: IBidResult;
}

export interface IValidationResult {
  valid: boolean;
  bidErrorMessage: BidMessageEnum;
  allQuantitiesZero: boolean;
}

export interface IMaintenance {
  corridorCode: string;
  offeredCapacity: number;
  atc: number;
  reducedOfferedCap: number;
  periodStart: Date;
  periodStop: Date;
  deliveryMinutes: number;
}

export interface IBook {
  name: string;
  code: string;
}

export interface IDocumentBookCode {
  bookCode: string;
  docId: string;
  corridorCode?: string;
}

export interface IUpdateDocumentBookCodeResult {
  updateSuccessful: boolean;
  documentBookCode: IDocumentBookCode;
  errorMessage: string;
}

export interface IExchangeConfig {
    id: number;
    corridorCode: string;
    outAreaEicCode: string;
    inAreaEicCode: string;
    productType: string;
    exchangeId: number;
    key: string;
    value: string;
    createdDateTime: Date;
    updatedDateTime: Date;
    isActive: boolean;
}

export interface IEtrmConfig {
    id: number;
    code: string;
    currency: string;
    importType: string;
    auditType: string;
    tradeType2: string;
    buySell: string;
    optType: string;
    mkt1: string;
    mkt2: string;
    comp1: string;
    comp2: string;
    book: string;
    firmType: string;
    schedule: string;
    broker: string;
    trader: string;
    contract: string;
    unit: string;
    period: string;
    days: string;
    tGroup1: string;
    tGroup4: string;
    timezone: string;
    inAreaEicCode: string;
    outAreaEicCode: string;
    corridorCode: string;
    createdDateTime: Date;
    updatedDateTime: Date;
}

export interface IProfile {
  userId: string,
  email: string,
  stratosRoles: any[],
  itaProdPolicy: ItaProdPolicy,
  itaNonProdPolicy: ItaNonProdPolicy,
  environment: ItaEnvironment
}

export interface IAuditLog {
  userId?: string | null;
  userName?: string | null;
  exchangeId?: number | null;
  auctionDateTime?: Date | null;
  auctionIdentification?: string | null;
  referenceNo?: string | null;
  action?: string | null;
  infoMessage?: string | null;
  createdOn: Date;
}

/**
 * Request payload for creating a capacity return
 */
export interface ICapacityReturnRequest {
  targetAuctionIdentification: string;
  targetAuctionName: string;
  sourceAuctionIdentification: string;
  sourceAuctionName: string;
  returnCapacity: number;
  bookCode: string;
  exchangeCode: string;
  exchangeId: number;
  corridor: string;
}

/**
 * Response from capacity return submission
 */
export interface ICapacityReturnResponse {
  returnSubmissionId?: string;
  returnSubmissionStatus: string;
  statusCode?: number;
  errorMessage?: string;
}

export enum FeatureHeadings {
  Auctions = "Auctions",
  ConfigurationManagement = "Configuration Management",
  ExchangeConfig = "Exchange Config",
  EtrmConfig = "Etrm Config",
  AuctionCalendar = "Auction Calendar",
  NotAuthenticated = "NotAuthenticated",
  Profile = "Profile",
  AccessDenied = "Access Denied",
  HealthChecks = "Health Checks",
}

export const MillisecondBeforeClosing = 1200000; //20mins

export { AuctionService } from "./Auction.service";

export { BidService } from "./Bid.service";

export { BookService } from "./Book.Service";

export { ExchangeConfigService } from "./ExchangeConfig.Service";

export { EtrmConfigService } from "./EtrmConfig.Service";

export { AuctionResultService } from "./AuctionResult.Service";

export { ProfileService } from "./Profile.service";